import { Injectable } from "@angular/core";
import { CanMatch, GuardResult, MaybeAsync, Route, Router, UrlSegment } from "@angular/router";
import { UserService } from "../api/service/user-service";


@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuard implements CanMatch {

    constructor(private userService: UserService, private router: Router) {}

    canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {

        if (this.userService.isTokenExpired()) {
            this.router.navigateByUrl('home')
            localStorage.clear();
            return false;
        }
        
        if (!this.userService.isAuthenticated()) {
            this.router.navigateByUrl('home');
            return false;
        }
        return true;
    }
    
}